export const BackgroundTaskStatus = {
    Queued: "Queued",
    Running: "Running",
    Completed: "Completed",
    CompletedWithErrors: "CompletedWithErrors",
    Error: "Error",
    Cancelled: "Cancelled"
};
/**
 * Kinds of background task (ProgressMessageCategory on the server). The panel never looks at these;
 * pages use them to react when a task they care about finishes.
 */
export const BackgroundTaskCategory = {
    ControllerImport: "ControllerImport"
};
/** Raised on window when one of the user's background tasks finishes; detail is the ProgressMessageModel. */
export const BackgroundTaskFinishedEvent = "assure:background-task-finished";
export function isFinishedStatus(status) {
    return status === BackgroundTaskStatus.Completed
        || status === BackgroundTaskStatus.CompletedWithErrors
        || status === BackgroundTaskStatus.Error
        || status === BackgroundTaskStatus.Cancelled;
}
export function parseBackgroundTaskDetails(details) {
    if (!details)
        return null;
    try {
        const parsed = JSON.parse(details);
        return parsed && Array.isArray(parsed.items) ? parsed : null;
    }
    catch (_a) {
        return null;
    }
}
